import { render, staticRenderFns } from "./PanicBuyTimeNode.vue?vue&type=template&id=0bff7c6f&scoped=true&"
import script from "./PanicBuyTimeNode.vue?vue&type=script&lang=js&"
export * from "./PanicBuyTimeNode.vue?vue&type=script&lang=js&"
import style0 from "./PanicBuyTimeNode.vue?vue&type=style&index=0&id=0bff7c6f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bff7c6f",
  null
  
)

export default component.exports